import { render, staticRenderFns } from "./UsageHistoryModule.vue?vue&type=template&id=47b45ac2&scoped=true"
import script from "./UsageHistoryModule.vue?vue&type=script&lang=js"
export * from "./UsageHistoryModule.vue?vue&type=script&lang=js"
import style0 from "./UsageHistoryModule.vue?vue&type=style&index=0&id=47b45ac2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b45ac2",
  null
  
)

export default component.exports